import { Box, ButtonV2, Flex, styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { ALLY_INK, BANK_PARTNER_PROMO_FONT_FAMILY } from './constants';

export const transferDialogOverrides = {
  Content: {
    props: {
      width: pxToRem(480),
      maxWidth: '100%',
    },
  },
};

export const allyTransferDialogOverrides = {
  Content: {
    props: {
      width: pxToRem(500),
      maxWidth: '100%',
    },
  },
};

export const TransferDialogBody = styled(Flex)`
  flex-direction: column;
  background: white;
  min-height: 100%;
`;

export const AllyEyebrow = styled(TextV2)`
  font-size: ${pxToRem(14)};
  font-weight: 600;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #8a8a8a;
  letter-spacing: 0.1px;
`;

export const AllyPromoHeadline = styled(TextV2)`
  font-size: ${pxToRem(30)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: ${ALLY_INK};
  line-height: 1.15;
  letter-spacing: -0.8px;
`;

export const AllyPromoSubtext = styled(TextV2)`
  font-size: ${pxToRem(17)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555555;
  line-height: 1.5;
  font-weight: 400;
`;

export const AllyAmountDisplay = styled(TextV2)`
  font-size: ${pxToRem(64)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -2.5px;
  line-height: 1;
`;

export const AllyBenefitsCard = styled(Box)`
  background: #f4f3f8;
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(20)} ${pxToRem(24)};
  width: 100%;
  text-align: left;
`;

export const AllyBenefitList = styled.ul`
  margin: 0;
  padding-left: ${pxToRem(20)};
  list-style: disc;
`;

export const AllyBenefitItem = styled.li`
  font-size: ${pxToRem(17)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #333333;
  line-height: 1.6;

  & + & {
    margin-top: ${pxToRem(6)};
  }
`;

export const AllyNudgeBar = styled(Flex)`
  background: #e9e2d8;
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(20)} ${pxToRem(20)};
  text-align: left;
  flex-direction: column;
  gap: ${pxToRem(16)};
`;

export const AllyNudgeText = styled(TextV2)`
  font-size: ${pxToRem(16)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #4a4a4a;
  line-height: 1.5;
`;

export const AllyPrimaryButton = styled(ButtonV2)`
  width: 100%;
`;

export const AllySecondaryButton = styled(ButtonV2)`
  width: 100%;
  && {
    color: #8a8a8a;
    border-color: #e0e0e0;
  }
  &&:hover {
    color: #5a5a5a;
    border-color: #c8c8c8;
  }
`;

export const AllyFinePrint = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #9a9a9a;
  line-height: 1.7;
`;

export const RevolutAmountPrefix = styled(TextV2)`
  font-size: ${pxToRem(48)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #111111;
  line-height: 1;
  white-space: nowrap;
`;

export const RevolutAmountDisplay = styled(TextV2)`
  font-size: ${pxToRem(52)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -3px;
  line-height: 1;
  margin-bottom: ${pxToRem(8)};
  transition: color 0.4s ease;
`;

export const RevolutApyDisplay = styled(TextV2)`
  font-size: ${pxToRem(48)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -2px;
  line-height: 1;
`;

export const RevolutAmountSubtext = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  letter-spacing: 0.2px;
`;

export const RevolutPromoHeadline = styled(TextV2)`
  font-size: ${pxToRem(22)};
  font-weight: 700;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #1a1a1a;
  line-height: 1.3;
`;

export const RevolutPromoSubtext = styled(TextV2)`
  font-size: ${pxToRem(18)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  line-height: 1.4;
  font-weight: 400;
`;

export const RevolutPrimaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(10)};
`;

export const RevolutSecondaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(16)};
  && {
    color: #666;
    border-width: 2px;
    border-color: #c0c0c0;
  }
  &&:hover {
    color: #444;
    border-color: #a0a0a0;
  }
`;

export const RevolutFinePrint = styled(TextV2)`
  font-size: ${pxToRem(11)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  line-height: 1.7;
`;

export const RevolutDisclaimerToggle = styled(TextV2)`
  font-size: ${pxToRem(11)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  text-decoration: underline;
  cursor: pointer;
  margin-top: ${pxToRem(8)};
  background: none;
  border: none;
  padding: 0;
`;
